<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <div class="container-fluid">
      <div class="p-2 border-bottom border-info">
        <h5 class="text-info font-italic">
          <strong><i class="fas fa-user-plus"></i> 参加者受付</strong>
        </h5>
      </div>
      <div>
        <b-form-group label="ID番号:">
          <b-form-input
                      id="userNo"
                      type="text"
                      size="16"
                      v-model="form.userNo"
                      :state="validators.userNo"
                      required
                      placeholder="ID番号を入力">
          </b-form-input>
          <b-form-invalid-feedback id="userNoFeedback">
            1文字以上を入力してください
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="参加測定会:">
          <b-form-input
                      id="groupId"
                      type="text"
                      size="13"
                      v-model="currentUserGroupIdAndName"
                      required
                      readonly
                      placeholder="">
          </b-form-input>
        </b-form-group>
        <b-form-group label="会員番号:">
          <b-form-input
                      id="userId"
                      type="text"
                      size="13"
                      v-model="form.userId"
                      :state="validators.userId"
                      required
                      placeholder="参加が二度目以上の場合は前回の番号を入力">
          </b-form-input>
          <b-form-invalid-feedback id="userIdFeedback">
            測定会番号＋ID番号の形式で入力してください
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="性別:">
          <b-form-radio-group id="gender"
                        buttons
                        button-variant="outline-primary"
                        v-model="form.gender"
                        required
                        :validated="validators.gender"
                        :options="genderOptions"
                        name="radiosBtnDefault">
                      </b-form-radio-group>
          <b-form-invalid-feedback id="genderFeedback" v-if="validators.gender">
            選択してください
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="生年月日:(日付は1日に固定されます)">
          <b-form-input
                      id="birthday"
                      type="date"
                      v-model="form.birthday"
                      :state="validators.birthday"
                      required
                      placeholder="">
          </b-form-input>
          <b-form-invalid-feedback id="birthdayFeedback">
            日付を選択してください
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="身長(cm):">
          <b-form-input
                      id="height"
                      type="number"
                      size="10"
                      v-model="form.height"
                      :state="validators.height"
                      required
                      placeholder="cm">
          </b-form-input>
          <b-form-invalid-feedback id="heightFeedback">
            身長を入力してください. (90-240cm)
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div>
        <b-button variant="success" @click="onRegister">参加受付登録</b-button>
      </div>
    </div>
    <hr>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/usergroups/' + $store.getters.currentUserGroup.groupId + '/top')">
        <span>戻る</span>
      </b-btn>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'

const logger = new Logger('UserRegister')

export default {
  name: 'UserRegister',
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      form: {
        userId: null,
        userNo: null,
        groupId: this.$store.getters.currentUserGroup.groupId,
        gender: '1',
        birthday: '1968-01-01',
        height: 165
      },
      validators: {
        userId: null,
        userNo: null,
        groupId: null,
        gender: null,
        birthday: null,
        height: null
      },
      genderOptions: [
        { text: '男性', value: '1' },
        { text: '女性', value: '2' }
      ]
    }
  },
  mounted () {
    logger.debug('q=', this.$route.query)
    this.form.userId = this.$route.query['userId'] || null
  },
  computed: {
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    },
    currentUserGroupIdAndName () {
      return this.$store.getters.currentUserGroup.groupId + ' ' + this.$store.getters.currentUserGroup.name
    }
  },
  methods: {
    validate () {
      // this.validators.userId = this.form.userId && /^[0-9]{13}$/.test(this.form.userId) ? true : false
      this.validators.userId = true
      this.validators.userNo = this.form.userNo
      this.validators.groupId = this.form.groupId
      this.validators.gender = /^[1|2]$/.test(this.form.gender)
      this.validators.birthday = this.form.birthday
      this.validators.height = this.form.height && this.form.height > 0
      return ['userId', 'userNo', 'groupId', 'gender', 'birthday', 'height'].every(p => this.validators[p])
    },
    onRegister () {
      this.error = null
      this.message = null
      this.form.groupId = this.currentUserGroup.groupId
      if (this.form.userNo) {
        this.form.userId = this.form.groupId + '-' + ('000' + this.form.userNo).slice(-3)
      }
      if (!this.validate()) {
        logger.debug(this.form)
        logger.debug(this.validators)
        return
      }
      logger.debug(this.form)
      let userData = Object.assign({}, this.$data.form)
      // userData.groupId = this.currentUserGroup.groupId
      userData.userGroup = Object.assign({}, this.currentUserGroup)

      this.loading = true
      return this.$store.dispatch('createUser', { newUser: userData }).then(() => {
        this.loading = false
        this.message = '登録しました'
        this.form = {
          userId: null,
          userNo: null,
          gender: '1',
          birthday: '1968-01-01',
          height: 165
        }
        this.validators = {
          userId: null,
          userNo: null,
          groupId: null,
          gender: null,
          birthday: null,
          height: null
        }
        return this.$router.push('/usergroups/' + this.currentUserGroup.groupId + '/users/' + userData.userId)
      }).catch(err => {
        this.loading = false
        logger.error('エラーが発生しました', err)
        // {"statusCode":400,"body":{"message":"user already entried:"}}
        if (err.message === '通信エラー: {"statusCode":400,"body":{"message":"user already entried:"}}') {
        // if (err.body && err.body.errorMessage === 'user already entried:') {
          this.error = 'その会員番号はすでに登録済みです'
        } else {
          this.error = err.message || err
        }
      })
    }
  }
}
</script>

<style scoped>
.step-table, .users-table {
  font-size: 0.75rem;
}
</style>
